var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuq-tip-container"},[_vm._t("default"),_vm._v(" "),_c('span',{class:_vm.className,domProps:{"innerHTML":_vm._s(_vm.tip)}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }